//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class SsrsReportModel extends ModelBase {
      static readonly $typeName = 'SsrsReportModel';
      public name: string;
      public permission: string;
      public reportPath: string;
      public type: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/report/models/SsrsReportModel.ts